export const isFocused = (element) => element === document.activeElement;
